module.exports = __webpack_public_path__ + "static/media/popup-message-bg.a7d2387a.png";